import { render, staticRenderFns } from "./WapFooter.vue?vue&type=template&id=5ae3633c&scoped=true&"
import script from "./WapFooter.vue?vue&type=script&lang=js&"
export * from "./WapFooter.vue?vue&type=script&lang=js&"
import style0 from "./WapFooter.vue?vue&type=style&index=0&id=5ae3633c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3633c",
  null
  
)

export default component.exports